import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {BankTransactionDashboardComponent} from './bank-transaction-dashboard/bank-transaction-dashboard.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BankTransactionDashboardComponent,
        data: {
          title: 'Dashboard'
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BankTransactionRoutingModule { }
